<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="cancel()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="labelButtons">Certification History</h4>
</div>
<div class="modal-body">
    <historical-customer-certification [customerNumberId]="data.customerNumberId"></historical-customer-certification>
</div>
<div class="modal-footer">
    <div class="btn--group">
        <button class="btn--primary" type="button" (click)="cancel()">Close</button>
    </div>
</div>
